import { Component } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';

import { BenchmarkSeries, BenchmarkSeriesItem, BenchmarkSeriesModel, FormCompAggregationSettingsViewItem } from "src/app/shared/benchmarks/benchmark-series";
import { DataService } from "src/app/shared/network/data.service";
import { ProjectService } from "src/app/shared/project/project.service";
import { BaseImportStepComponent, ImportStepState } from "../base-import-step.component";
import { ImportStep } from "../import-step";
import { AggregationMethod, AggregationType } from "src/app/shared/preaggregation/aggregation-method";

@Component({
    selector: 'forecast',
    templateUrl: './forecast.component.html',
    styleUrls: ['../general.scss', './series.component.scss']
})
export class ForecastComponent extends BaseImportStepComponent {
    AggregationType: typeof AggregationType = AggregationType;   //hack for enum to be available in the template
    readonly step = ImportStep.Forecast;
    public loading = true;
    public oldControlValue: string;
    public newControlValue: string;
    public series: BenchmarkSeries[];
    public selectedSeriesName: string;
    public haveEligibleForForecast = false;
    public selectedAsForecast = [];

    public outcomeName = 'Outcome';
    public someDimensionName = 'dimension';
    public showHint = false;
    public firstNotEligibleControlVal = '';
    public haveFormCompAggrTypeAverage = false;
    public formCompItems: FormCompAggregationSettingsViewItem[];

    constructor(private dataService: DataService, projectService: ProjectService, public dialog: MatDialog) {
        super(projectService);
    }
    
    public async loadDataInternal(): Promise<void> {
        let res = await this.dataService.get<BenchmarkSeriesModel>(`benchmarks/forecast/${this.projectId}`);
        this.stepState = res.stepState;
        if (this.stepState <= ImportStepState.NotAvailableYet) {
            return;
        }
        this.series = res.series;
        this.oldControlValue = res.oldControlValue;
        this.newControlValue = res.newControlValue;
        this.selectedSeriesName = res.selectedSeriesName;
        this.outcomeName = res.outcomeName;
        this.someDimensionName = res.someDimensionName;
        console.log('formCompItems', res.formCompAggregationSettings);
        this.formCompItems = res.formCompAggregationSettings;
        this.haveFormCompAggrTypeAverage = res.formCompAggregationSettings?.filter(fc => fc.aggregationMethod.type === AggregationType.averageWeighted || fc.aggregationMethod.type === AggregationType.average).length > 0;
        this.loadSelectedAsForecastList();
        this.initHint();
        this.loading = false;
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    async saveSeries() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            const changesApplied = await this.dataService.post<boolean>('benchmarks/saveSeries', {
                projectId: this.projectId,
                series: this.series,
                selectedSeriesName: this.selectedSeriesName
            });
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }

    selectAsForecast(item: BenchmarkSeriesItem): void {
        item.isSelectedAsForecast = true;
        this.loadSelectedAsForecastList();
    }

    unSelectAsForecast(item: BenchmarkSeriesItem): void {
        item.isSelectedAsForecast = false;
        this.loadSelectedAsForecastList();
    }

    handleCurrentEligibilityAsForecast() {
        if (!this.series) {
            return;
        }

        let seriesIxWithSelectedAsForecast: number = undefined;
        for (let i = 0; i < this.series.length; ++i) {
            for (let j = 0; j < this.series[i].items.length; ++j) {
                if (this.series[i].items[j] && this.series[i].items[j].isSelectedAsForecast) {
                    seriesIxWithSelectedAsForecast = i;
                    break;
                }
            }
        }
        for (let i = 0; i < this.series.length; ++i) {
            for (let j = 0; j < this.series[i].items.length; ++j) {
                if (this.series[i].items[j]) {
                    this.series[i].items[j].isCurrentlyEligibleAsForecast = (seriesIxWithSelectedAsForecast === undefined || seriesIxWithSelectedAsForecast == i);
                }
            }
        }
    }

    initHint(): void {
        this.showHint = false;
        if (this.series) {
            let minJ = Number.MAX_VALUE;
            for (let i = 0; i < this.series.length; ++i) {
                for (let j = 0; j < this.series[i].items.length; ++j) {
                    if (this.series[i].items[j] && !this.series[i].items[j].isEligibleAsForecast) {
                        this.showHint = true;
                        if (j < minJ) {
                            minJ = j;
                            this.firstNotEligibleControlVal = this.series[i].items[j].controlValue;
                        }
                    }
                }
            }
        }
    }

    loadSelectedAsForecastList(): void {
        if (!this.series) {
            return;
        }
        let haveEligible = false;
        let result: string[] = [];
        for (let i = 0; i < this.series.length; ++i) {
            for (let j = 0; j < this.series[i].items.length; ++j) {
                if (this.series[i].items[j]) {
                    if (this.series[i].items[j].isSelectedAsForecast) {
                        result.push(this.series[i].items[j].controlValue);
                    }
                    if (this.series[i].items[j].isEligibleAsForecast) {
                        haveEligible = true;
                    }
                }
            }
        }
        this.selectedAsForecast = result;
        this.haveEligibleForForecast = haveEligible;
        this.handleCurrentEligibilityAsForecast();
    }

    public get nonExcludedSeriesCount(): number {
        return this.series ? this.series.filter(s => !s.isExclude).length : 0;
    }

}
